"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindowMessageService = void 0;
var rxjs_1 = require("rxjs");
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
/**
 * The WindowMessageService facilitates communication between iframes within the Seismic environment. In many instances, the Seismic Web App will be hosted within an iframe such as in Salesforce, Hubspot, or other CRM’s. When used with a sandbox attribute, there are many limitations placed on the iframes and window.postMessage may be the only way to communicate between our iframes since sandbox attributes are passed in recursively from their parent iframe.
 */
var WindowMessageService = /** @class */ (function () {
    function WindowMessageService() {
        var _this = this;
        this.onWindowMessage = function (event) {
            if (!event.data || !event.data.seismicMessageId) {
                // Ignore non seismic messages
                return;
            }
            _this.messageSubject.next({
                id: event.data.seismicMessageId,
                data: event.data.data,
                event: event,
            });
        };
        this.messageSubject = new rxjs_1.Subject();
        this.message = this.messageSubject.asObservable();
        this.bindToWindow(window);
    }
    /**
     * Send a message to the target window (Defaults to current window)
     * @param id The id to differentiate the message from other messages
     * @param data
     * @param targetOrigin
     * @param messageWindow Useful for when you want to adhere to ISeismicWindowMessage where SeismicCommon is not available and you have access to the window
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    WindowMessageService.prototype.postMessage = function (id, data, targetOrigin, messageWindow) {
        if (targetOrigin === void 0) { targetOrigin = '*'; }
        if (messageWindow === void 0) { messageWindow = window; }
        messageWindow.postMessage({ seismicMessageId: id, data: data }, targetOrigin);
    };
    /**
     * Subscribe to a specific seismicMessageId
     * @param seismicMessageId The id of the window message you want to listen for
     * @param callback
     * @returns {Function} Unsubscribe function
     */
    WindowMessageService.prototype.subscribe = function (seismicMessageId, callback) {
        var subscription = this.messageSubject.subscribe({
            next: function (event) {
                if (event.id === seismicMessageId) {
                    callback(event);
                }
            },
        });
        return function () {
            subscription.unsubscribe();
        };
    };
    WindowMessageService.prototype.bindToWindow = function (window) {
        window.addEventListener('message', this.onWindowMessage);
    };
    WindowMessageService = __decorate([
        (0, CommonService_decorator_1.CommonService)('WindowMessageService'),
        __metadata("design:paramtypes", [])
    ], WindowMessageService);
    return WindowMessageService;
}());
exports.WindowMessageService = WindowMessageService;
//# sourceMappingURL=WindowMessage.service.js.map